(() => {
  const SELECTOR = '[data-animate]';
  const LOAD_SELECTOR = '[data-animate-on-load]';
  const HEADER_SELECTOR = '[data-header-animate]';

  let observer;

  const prefersReducedMotion = () => {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  const makeVisible = (element) => {
    element.classList.add('is-visible');

    if (observer) {
      observer.unobserve(element);
    }
  };

  const prepareAnimationOrder = (container = document) => {
    container.querySelectorAll('[data-animate-group]').forEach((group) => {
      const animatedChildren = group.querySelectorAll(SELECTOR);

      animatedChildren.forEach((element, index) => {
        if (!element.style.getPropertyValue('--animation-order')) {
          element.style.setProperty('--animation-order', index);
        }
      });
    });
  };

  const revealInitialElements = (container = document) => {
    const initialElements = container.querySelectorAll(
      `${LOAD_SELECTOR}, ${HEADER_SELECTOR}`
    );

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initialElements.forEach((element) => {
          element.classList.add('is-visible');
        });
      });
    });
  };

  const observeElements = (container = document) => {
    const elements = container.querySelectorAll(
      `${SELECTOR}:not([data-animate-on-load])`
    );

    elements.forEach((element) => {
      if (element.classList.contains('is-visible')) return;

      observer.observe(element);
    });
  };

  const initializeAnimations = (container = document) => {
    prepareAnimationOrder(container);

    if (prefersReducedMotion()) {
      container.querySelectorAll(SELECTOR).forEach(makeVisible);
      container.querySelectorAll(HEADER_SELECTOR).forEach(makeVisible);
      return;
    }

    revealInitialElements(container);
    observeElements(container);
  };

  const createObserver = () => {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          makeVisible(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12
      }
    );
  };

  const initialize = () => {
    document.documentElement.classList.add(
      'atelier-animations-enabled'
    );

    createObserver();
    initializeAnimations(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  /*
   * Reinitialize sections when they are loaded through
   * the Shopify Theme Editor.
   */
  document.addEventListener('shopify:section:load', (event) => {
    initializeAnimations(event.target);
  });
})();